import { motion } from "framer-motion";

const SITE = "https://www.essexphotographystudio.co.uk";

const sessions = [
  {
    title: "Newborn Photoshoots",
    desc: "Your premium choice for a newborn photoshoot in Essex — join the WVE Studios Baby & Family Club and capture the most precious memories of family life.",
    img: "https://static.wixstatic.com/media/1e3034_e86461ba815449aab1ffec16985321b6~mv2.jpg/v1/fill/w_600,h_750,al_c,q_85/newborn.jpg",
    link: `${SITE}/newborn-photoshoots`,
  },
  {
    title: "Maternity Photoshoots",
    desc: "Luxury maternity photoshoots at our Wickford studio. Your moment to feel seen, celebrated and confident — exactly as you are.",
    img: "https://static.wixstatic.com/media/1e3034_227a6f5c72e04f46b6962e0d04e143c7~mv2.jpg/v1/fill/w_600,h_750,al_c,q_85/maternity.jpg",
    link: `${SITE}/maternity-photoshoots`,
  },
  {
    title: "Cake Smash",
    desc: "Celebrate your little one's first birthday in a fun, relaxed and memorable way — joyful, expressive images that capture their personality.",
    img: "https://static.wixstatic.com/media/1e3034_87dab658878244b3946ac5a96ee45e47~mv2.jpg/v1/fill/w_600,h_750,al_c,q_85/cakesmash.jpg",
    link: `${SITE}/cake-smash-experience`,
  },
  {
    title: "Family Portraits",
    desc: "Portraits that celebrate connection, personality and real moments — with plenty of time for outfit changes, group variations and little ones.",
    img: "https://static.wixstatic.com/media/1e3034_dbfcbdee238c4e4eae1343bc77fc0cee~mv2.jpg/v1/fill/w_600,h_750,al_c,q_85/family.jpg",
    link: `${SITE}/family-portrait-experience`,
  },
];

export const Photography = () => (
  <section id="photography" className="py-24 sm:py-32 bg-white border-y border-black/10" data-testid="photography-section">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-16 flex flex-wrap items-end justify-between gap-6"
      >
        <div>
          <p className="text-sm uppercase tracking-[0.3em] font-semibold text-[#E80042] mb-4">04 — Portraits & Experiences</p>
          <h2 className="font-grotesk font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none max-w-3xl">
            Little moments, <span className="text-[#E80042]">big memories.</span>
          </h2>
        </div>
        <p className="max-w-sm text-[#555555] text-base leading-relaxed">
          Our purpose-built Wickford photo studio is Essex's leading choice for newborn photography, cake smashes & family sessions.
        </p>
      </motion.div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {sessions.map((s, i) => (
          <motion.a
            key={s.title}
            href={s.link}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`photography-card-${i + 1}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (i % 4) * 0.1 }}
            className={`group block ${i % 2 === 1 ? "lg:mt-10" : ""}`}
          >
            <div className="relative overflow-hidden rounded-lg">
              <img src={s.img} alt={s.title} className="w-full h-[340px] object-cover group-hover:scale-105 transition-transform duration-500" />
              <span className="absolute top-4 right-4 w-9 h-9 rounded-full bg-[#E80042] text-white flex items-center justify-center opacity-0 group-hover:opacity-100 -rotate-45 transition-opacity duration-300">↗</span>
              <div className="absolute inset-x-0 bottom-0 h-1.5 bg-[#E80042] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
            </div>
            <h3 className="font-display uppercase text-2xl mt-5 tracking-tight group-hover:text-[#E80042] transition-colors duration-300">{s.title}</h3>
            <p className="text-[#555555] text-sm leading-relaxed mt-2">{s.desc}</p>
          </motion.a>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 0.7 }}
        className="mt-16 bg-[#0A0A0A] text-white rounded-lg px-8 py-10 flex flex-wrap items-center justify-between gap-6"
      >
        <div>
          <h3 className="font-display uppercase text-3xl sm:text-4xl tracking-tight">Essex Photography Studio</h3>
          <p className="text-white/60 mt-2 max-w-lg">Printed portraits, handcrafted wall art and keepsakes made to be lived with every day — with a no-pressure viewing approach.</p>
        </div>
        <a
          href={SITE}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="photography-site-link"
          className="bg-[#E80042] text-white font-grotesk font-bold text-lg px-9 py-4 rounded-full hover:bg-white hover:text-[#0A0A0A] transition-colors duration-300 active:scale-95"
        >
          Visit the Photo Studio ↗
        </a>
      </motion.div>
    </div>
  </section>
);
